import React from "react"
import styles from "./StripeAccountCard.module.css"
import stripeIcon from "assets/imagesV2/settings/stripe.svg"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import { StripeActionButtons } from "./StripeActionButtons"
import { useDevice } from "hooks/useDevice"
import { StripeStatus } from "./StripeStatus"
import { StripeDetails } from "./StripeDetail"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import { useSelector } from "react-redux"
import PropTypes from 'prop-types';
import { isStripeChargesEnabledSelector, isStripePayoutsEmail,errorStripeMessage ,stripeLinkSelector} from "store/user"

export const StripeAccountCard = ({ className}) => {
  const { isMobile } = useDevice()
  const { t } = useTranslation()
  const stripeEmail = useSelector(isStripePayoutsEmail)
  const isStripeChargeEnabled = useSelector(isStripeChargesEnabledSelector)
  const stripeErrorMessage = useSelector(errorStripeMessage)
  const stripeAttachLink = useSelector(stripeLinkSelector)
  return (
    <div className={classNames(styles.wrapper, className)}>
      <Flex gap={spacings.M} align="start">
        <img src={stripeIcon} alt={"Stripe icon"} className={styles.stripeLogo} />
        <Flex vertical>
          <div className={styles.title}>Stripe</div>
          <div className={styles.account}></div>
          <div className={styles.accountDescription}>{t("pro.personal_info.stripe.card_description")}</div>
          {isMobile && <StripeStatus />}
          <StripeDetails 
            stripeEmail={stripeEmail} 
            errorStripeMessage={stripeErrorMessage}
            isStripeChargeEnabled={isStripeChargeEnabled} 
            stripeLink={stripeAttachLink}
          />
        </Flex>
      </Flex>
      {!isMobile && (
        <Flex gap={spacings["3XL"]}>
          <StripeStatus />
          <StripeActionButtons />
        </Flex>
      )}
    </div>
  )
}

StripeAccountCard.propTypes = {
  className: PropTypes.string,
};